import { BRAND_SHORT } from "./brand";
import {
  ACCOUNTING_HOST,
  MARKETPLACE_HOST,
  OPS_HOST,
  buildHostUrl,
  isAccountingHost,
} from "./hostRouting";

function getBrowserHostname() {
  if (typeof window === "undefined") return "";
  return (window.location.hostname || "").toLowerCase();
}

export function detectBrandHostname(explicitHostname = "") {
  return (explicitHostname || getBrowserHostname() || "").toLowerCase();
}

export function isMarketplaceHostname(hostname = "", forcedMode = "") {
  const normalizedMode = (forcedMode || "").trim().toLowerCase();
  const normalizedHost = detectBrandHostname(hostname);
  return normalizedMode === "marketplace" || normalizedHost.includes("myboothshare");
}

export function isAccountingHostname(hostname = "", forcedMode = "") {
  const normalizedMode = (forcedMode || "").trim().toLowerCase();
  const normalizedHost = detectBrandHostname(hostname);
  return normalizedMode === "accounting" || isAccountingHost(normalizedHost);
}

export function getBrandConfig(options = {}) {
  const hostname = detectBrandHostname(options.hostname);
  const forcedMode = options.forcedMode ?? process.env.REACT_APP_BRAND_MODE;
  const marketplaceHost = isMarketplaceHostname(hostname, forcedMode);
  const accountingHost = !marketplaceHost && isAccountingHostname(hostname, forcedMode);

  return {
    hostname,
    isMarketplaceHost: marketplaceHost,
    isAccountingHost: accountingHost,
    brandKey: accountingHost ? "salonbusinesscpa" : marketplaceHost ? "myboothshare" : "ellyanna",
    appLabel: accountingHost
      ? `${BRAND_SHORT} SalonBusinessCPA`
      : marketplaceHost
      ? `${BRAND_SHORT} MyBoothShare`
      : BRAND_SHORT,
    documentTitle: marketplaceHost
      ? `${BRAND_SHORT} MyBoothShare`
      : accountingHost
      ? `${BRAND_SHORT} SalonBusinessCPA`
      : "Ellyanna - Salon Booking and Intelligence Network",
    publicHomePath: "/",
    primarySearchPath: "/search",
    publicNavLabel: marketplaceHost ? "Marketplace" : "Find Workspaces",
    opsHost: OPS_HOST,
    marketplaceHostName: MARKETPLACE_HOST,
    accountingHostName: ACCOUNTING_HOST,
    opsHomeUrl: buildHostUrl(OPS_HOST, "/manager/schedule"),
    opsLoginUrl: buildHostUrl(OPS_HOST, "/login"),
    marketplaceHomeUrl: buildHostUrl(MARKETPLACE_HOST, "/"),
    marketplaceOperatorUrl: buildHostUrl(
      MARKETPLACE_HOST,
      "/account/operator"
    ),
    marketplaceSearchUrl: buildHostUrl(MARKETPLACE_HOST, "/search"),
    shellLabel: marketplaceHost ? "Ellyanna MyBoothShare" : "Ellyanna Dashboard",
  };
}
